export const MAIN_STORAGE_KEY = '__recapt_storage';

export const MANUAL_SESSION_SAVE_SESSION_KEY = '__recapt_save_session';

export const SESSION_IDENTITY_STORAGE_KEY = '__recapt_identity';

export const SESSION_ID_KEY = '__recapt_session_id';

export const SESSION_START_OPTIONS_KEY = '__recapt_start_options';

export const SESSION_PERSISTANT_PAUSE_KEY = '__recapt_persistant_pause';

export const SESSION_TAGS_STORAGE_KEY = '__recapt_tags';

export const LAST_REQUEST_TIME_SESSION_STORAGE_KEY = '__recapt_lrt';

export const OBFUSCATION_SELECTOR_STORAGE_KEY = '__recapt_obfuscation_selector';

export const RECORD_ENGINE_STORAGE_KEY = '__recapt_record_engine';
